import styled from 'styled-components'
export const EntryLayout = styled.div`
    display: grid;
    grid-template-columns: fit-content(250px) 4fr;
    grid-template-rows: 60px 1fr;
    grid-template-areas:
        'header header'
        'sidebar main';
    height: 100vh;
`
export const Main = styled.div<{noPadding: boolean}>`
    ${({ noPadding }) => !noPadding && 'padding: 0 24px;'};
    min-width: 0;
    @media (max-width: 768px) {
        ${({ noPadding }) => !noPadding && 'padding: 0 12px;'};
    }
    grid-area: main;
    max-height: 100vh;
    overflow-y: auto;
    position: relative;
`
